<template>
  <div>
    <el-dialog
      title="新增指标"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      append-to-body
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <el-form :model="filters" class="toolbar" ref="filters" :rules="rules" label-width="100px">
        <el-row style="padding-bottom: 10px;" type="flex" justify="center">
          <el-col :span="12">
            <el-form-item label="权重指标" prop="wfdKey">
              <el-select v-model="filters.wfdKey" filterable placeholder="请选择" v-if="addType == 'secondTarget'">
                <el-option
                  v-for="(item,i) in weightFactorDefineList"
                  :key="i"
                  :label="item.wfdName + ' '"
                  :value="item.wfdKey + ''"
                ></el-option>
              </el-select>
              <el-input v-model="filters.wfdKey" type="text" v-if="addType == 'firstTarget'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-bottom: 10px;" type="flex" justify="center">
          <el-col :span="12">
            <el-form-item label="占比" prop="mrdPercentage">
              <el-input v-model="filters.mrdPercentage" style="width:90%"></el-input>
              <span style="width:5%;margin:auto;">%</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-bottom: 10px;" type="flex" justify="center">
          <el-col :span="12" style="display:flex;justify-content:space-between;">
            <el-form-item label="取值范围" prop="mrdRangeStart">
              <el-input placeholder="区间范围开始" v-model="filters.mrdRangeStart"></el-input>
            </el-form-item>
            <span class="dataSpinner">-</span>
            <el-form-item class="mrdRangeEnd" prop="mrdRangeEnd">
              <el-input placeholder="区间范围结束" v-model="filters.mrdRangeEnd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dalog-footer">
        <el-button type="primary" @click="addRulealterAppDetail()" :loading="listLoading">添加</el-button>
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mrId: {
      type: String,
      default: null
    },
    mrdPid: {
      type: Number,
      default: null
    },
    rowIndex: {
      type: Number,
      default: -1
    },
    weightList: {
      type: Array,
      default: []
    },
    filtersList: {
      type: Object,
      default() {
        return {};
      }
    },
    addType: {
      type: String,
      default: null
    },
  },
  data: function() {
    return {
      listLoading: false,
      weightFactorDefineList: [],
      filters: {},
      rules: {
        wfdKey: [
          { required: true, message: "请选择权重指标", trigger: "change" }
        ],
        mrdPercentage: [
          { required: true, message: "请选择占比", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
    getWeightFactorDefine() {
      var _this = this;
      let wfdLevel = 1;
      if (_this.mrdPid != null) {
        wfdLevel = 2;
      }
      let para = {
        wfdLevel: wfdLevel
      };
      this.listLoading = true;
      this.$api.selectgoods.getWeightFactorDefine(para).then(res => {
        this.weightFactorDefineList = res.data.result;
        this.listLoading = false;
      });
    },
    validatePercentage() {
      let _this = this;
      let sum = 0;
      let pid;
      if (_this.mrdPid == null) {
        for (var i = 0; i < _this.weightList.length; i++) {
          pid = _this.weightList[i].mrdPid;
          if (pid == null) {
            sum += Number(_this.weightList[i].mrdPercentage);
          }
        }
    
        if (sum + Number(_this.filters.mrdPercentage) > 100) {
          this.$message(
            "添加一级指标失败，一级指标指标占比不能超过100，除当前新增指标外一级指标占比和为" +
              sum +
              ",当前最高占比不能超过" +
              (100 - sum)
          );
          return false;
        } else {
          return true;
        }
      } else {
        let msg = "";
        for (var i = 0; i < _this.weightList.length; i++) {
          pid = _this.weightList[i].mrdPid;
          if (pid == _this.mrdPid) {
            console.log(pid,_this.weightList[i].mrdKey)
            sum += Number(_this.weightList[i].mrdPercentage);
            if (_this.weightList[i].mrdKey == _this.filters.wfdKey) {
              msg += "添加二级指标失败，同一一级指标指标下的二级指标不能相同;";
            }
          }
        }
        
        if (sum + Number(_this.filters.mrdPercentage) > 100) {
          msg +=
            "添加二级指标失败，同一一级指标指标下的二级指标占比和不能超过100，除当前新增指标外二级指标占比和为" +
            sum +
            ",当前最高占比不能超过" +
            (100 - sum) +
            ";";
        }
        if (msg.length > 0) {
          this.$message(msg);
          return false;
        } else {
          return true;
        }
      }
    },
    addRulealterAppDetail() {
      var _this = this;
      this.$refs["filters"].validate(valid => {
        if (valid && _this.validatePercentage()) {
          var mrdMode = '';
          var mrdIndication = '';
          var mrdPogcode = '';
          if (_this.weightList.length > 0) {
            mrdPogcode= _this.weightList[0].mrdPogcode;
            mrdMode= _this.weightList[0].mrdMode;
            mrdIndication= _this.weightList[0].mrdIndication;
          }else{
            mrdPogcode = '';
            mrdMode = _this.filtersList.mrdMode;
            mrdIndication = _this.filtersList.mrdIndication;
          }
          let para = {
            mrId: _this.mrId, //申请单流水号
            mrdPogcode: mrdPogcode, //对应棚格图编码
            mrdMode: mrdMode, //选品模式
            mrdIndication: mrdIndication, //选品指标
            mrdKey: _this.filters.wfdKey, //权重指标
            mrdPercentage: _this.filters.mrdPercentage, //权重指标占比
            mrdRangeStart: _this.filters.mrdRangeStart, //区间范围开始
            mrdRangeEnd: _this.filters.mrdRangeEnd, //区间范围结束
            mrdRule: null, //操作规则
            mrdPid: _this.mrdPid, //父指标
            mrdColumnKey: null //关联字段
            //    mrdAggrcolumnkey: _this.weightList[0].wfdAggrcolumnkey //统计报表占比字段
          };
          this.listLoading = true;
          this.$api.selectgoods.addRulealterAppDetail(para).then(res => {
            if (_this.mrdPid == null) {
              _this.weightList.push(res.data.object);
            } else {
              for (var i = _this.rowIndex; i < _this.weightList.length; i++) {
                if (_this.weightList[i].mrdPid == null) {
                  _this.weightList.splice(i + 1, 0, res.data.object);
                  break;
                }
              }
            }
            _this.$emit("update:weightList", this.weightList);
            _this.$emit("update:visible", false);
            // _this.$emit("refreshQuery");
            _this.listLoading = false;
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getWeightFactorDefine();
  }
};
</script>
<style>
.mrdRangeEnd .el-form-item__content,
.dataSpinner {
  margin-left: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/rules/addIndex.vue